import { useTranslation } from 'react-i18next';

const usePublicationStep = () => {
  const { t } = useTranslation();
  return {
    t,
  };
};

export default usePublicationStep;
